import get from '@invitato/helpers/dist/getLocale';

export default {
  buttonSubtitle: get('Klik untuk melihat detail', 'Click for details')
};